import {
    ExternalImagesOptions,
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';
import { logUsage } from 'owa-analytics';
import dataPoints from '../datapoints';
import getSelectedOptionKey from '../selectors/getSelectedOptionKey';
import updateExternalImagesOption from '../data/mutators/updateExternalImagesOption';

/**
 * Function which makes service call to save the updated value.
 */
export default async function saveExternalImagesOption() {
    const { name: eventName, customData } = dataPoints.ExternalImageProxySetting.datapoint;
    const userOptions = getOptionsForFeature<ExternalImagesOptions>(
        OwsOptionsFeatureType.ExternalImages
    );
    const selectedOption = getSelectedOptionKey();
    updateExternalImagesOption(userOptions, selectedOption);

    await lazyCreateOrUpdateOptionsForFeature
        .importAndExecute(OwsOptionsFeatureType.ExternalImages, userOptions)
        .catch(error => null);

    logUsage(eventName, customData(selectedOption));
}
